import { createContext } from "react";
import { Assessment, Quiz } from "sj-ui-toolkit/src/api/types/quizTypes";

export const VideoContext = createContext({
  // Lesson state
  inLessonMode: false as boolean,
  onLessonClick: () => {},
  isLessonComplete: false as boolean,
  onLessonFinish: () => {},
  nextLesson: null as number | null,
  exerciseOnly: false as boolean,

  // Quiz state
  inQuizMode: false as boolean,
  setInQuizMode: (_inQuizMode: boolean) => {},
  quiz: {
    assessment: {
      id: 0,
      answersCount: 0,
      questionsCount: 0,
      assessmentScore: 0,
      result: "",
    },
  } as Quiz,
  onQuizTake: async () => {},
  onQuizFinish: (_quizData: Assessment) => {},
  onQuizRetake: async () => {},
  selectedOption: null as string | null,
  onAnswerSelect: (_slug: string) => {},
  onQuizReview: () => {},
  onQuestionSubmit: async (_slug: string, _questionId: string) => {},
  onQuestionContinue: () => {},
  submissionData: {} as Assessment | null,
  selectedOptions: {} as Record<number, string>,
  onMultiAnswerSelect: (_questionId: number, _slug: string) => {},
  onQuizSubmit: async () => {},

  // Feedback modal state
  feedbackModalVisible: false as boolean,
  openFeedbackModal: () => {},
  closeFeedbackModal: () => {},

  // Exercise state
  inExerciseMode: false as boolean,
  setInExerciseMode: (_inExerciseMode: boolean) => {},
  onExerciseLaunch: () => {},
  isExercisePassed: false as boolean,
  onExercisePassed: () => {},

  // Tournament state
  tournamentUuid: undefined as string | undefined,
});
